import React from 'react';

import Chip from '@mui/material/Chip';

import { Role } from 'stores/AuthenticationStoreAdapter';

const RoleColor: Record<Role, string> = {
  ADMIN: '#d32f2f',
  GENERAL: '#1976d2',
  MANAGER: '#388e3c',
  BACK_OFFICE: '#7b1fa2',
  DEVELOPER: '#f57c00',
};

type Props = {
  role: Role;
  size?: 'small' | 'medium';
  variant?: 'filled' | 'outlined';
  onClick?: () => void;
};

const RoleChip: React.FC<Props> = ({ role, size = 'medium', variant = 'outlined', onClick }) => {
  const color = RoleColor[role];

  return (
    <Chip
      label={Role[role]}
      size={size}
      variant={variant}
      onClick={onClick}
      sx={{
        color: variant === 'outlined' ? color : '#fff',
        borderColor: color,
        backgroundColor: variant === 'filled' ? color : undefined,
        cursor: onClick ? 'pointer' : 'default',
        fontWeight: 400,
        ...(size === 'small' && { height: 20, fontSize: '0.7rem' }),
      }}
    />
  );
};

export default RoleChip;
